<template>
  <page-wrapper :title="title" ref="pageEl">
    <div class="header" v-show="false">
      <sc-button
        class="create-button"
        variant="primary"
        :route="createPackageButton.route"
      >{{ createPackageButton.text }}</sc-button>
    </div>
    <div class="wrapper">
      <div class="row mb-3">
        <div class="col-3">
          <div class="label mb-2">ชื่อแพ็กเกจ</div>
          <el-input v-model="packageName" />
        </div>
      </div>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
      </div>
      <div v-if="list.length">
        <p class="mb-2 mt-2">{{ totalCount }}</p>
        <div>
          <package-list-item v-for="item in list" :value="item" :key="item.key"></package-list-item>
          <div class="text-right mt-4" v-if="list.length">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :size="10"
              :current-page="queryParams.page"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else class="text-center p-5">
        <h3>ไม่มีข้อมูล</h3>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "@/lib/components/ScButton";
import PackageListItem from "../components/PackageListItem";
import { baanRueJaiClient } from "@/dependencies";
import { Input, Pagination } from "element-ui";
import { toCamelCaseObject } from '@/lib/util';

export default {
  components: {
    PageWrapper,
    PackageListItem,
    ScButton,
    "el-input": Input,
    "el-pagination": Pagination,
    ProjectSelect
  },
  data() {
    const title = "รายการ Ruejai Club Sale Package";
    const createPackageButton = {
      text: "เพิ่มแพ็กเกจ",
      route: { name: "RuejaiClubSalePackageCreatePage" }
    };
    const list = [];
    const total = 0;
    const packageName = null;

    return {
      title,
      list,
      createPackageButton,
      packageName,
      total
    };
  },
  computed: {
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1,
        name: this.$route.query.name || null
      };
    }
  },
  mounted() {
    this.setup();
  },
  watch: {
    async "$route.query"(query) {
      await this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    }
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      this.packageName = this.$route.query.name;
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const params = this.queryParams;
      const { total_count, items } = await this.fetchList(params);
      this.total = total_count;

      this.list = items.map(item => {
        const {
          id,
          subscription_package
        } = item;

        const {
          id: subscriptionPackageId,
          name,
          price,
          billing_cycle: billingCycle,
          target,
          detail,
          image_url: imageUrl,
          original_Price: originalPrice,
          thumbnail_url: thumbnailUrl
        } = subscription_package;

        const params = {
          id,
          subscriptionPackageId
        }

        const route = { name: "RuejaiClubSalePackageDetailPage", params };

        return {
          id,
          route,
          subscriptionPackageId,
          name,
          price,
          billingCycle,
          target,
          detail,
          imageUrl,
          originalPrice,
          thumbnailUrl
        };
      });
    },
    async fetchList(params) {
      const response = await baanRueJaiClient.admin.ruejaiClub.salePackages.list(
        params
      );

      return response.data.result;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    async handleClickSearch() {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: 1,
          name: this.packageName
        }
      };

      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: row;
  flex-flow: row nowrap;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.wrapper {
  padding: ($space / 2) $space;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/sale-package/pages/RuejaiClubSalePackageListPage.vue